import Link from "next/link";
import styles from "./index.module.css";

export const FinalCta = () => (
  <div className={styles.finalCtaWrap}>
    <div className={styles.finalCta}>
      <div className={styles.finalCtaText}>
        <h2 className={styles.finalCtaH2}>
          Stop showing your friends localhost:3000.
          <br />
          <em>Get a real link.</em>
        </h2>
      </div>
      <div className={styles.finalCtaActions}>
        <Link
          href="/dashboard"
          className={`${styles.finalCtaBtn} plausible-event-name=L2_TrialStarted`}
        >
          Start with a free trial →
        </Link>
        <Link
          href="/pricing"
          className={`${styles.finalCtaSecondary} plausible-event-name=L2_SeePricing`}
        >
          See pricing
        </Link>
      </div>
    </div>
  </div>
);
